"use strict";angular.module("app").run(function(amMoment){amMoment.changeLocale("fr")});